import { Controller } from "@hotwired/stimulus";

export class SegmentLogoutLinkController extends Controller {
  connect() {
    this.element.addEventListener("click", () => {
      analytics.reset();
    });
  }
}
